<template>
  <div class="possibleWinWrapper">
    <div class="possibleWin">
      <div>
        {{ translations.general_possible_winning }}
      </div>
      <div>
        {{ decimalFormatNumber(possibleWinCombo.possibleWinnings) }}
      </div>
    </div>
    <div class="payinTax" v-if="isPayinTaxActive">
      <div>
        {{ translations.general_payin_tax }}
      </div>
      <div>
        {{ decimalFormatNumber(possibleWinCombo.possiblePayinTax) }}
      </div>
    </div>
    <div class="payoutTax"
         v-if="isPayoutTaxActive && Number(possibleWinCombo.possiblePayoutTax) > 0">
      <div>
        {{ translations.general_payout_tax }}
      </div>
      <div>
        {{ decimalFormatNumber(possibleWinCombo.possiblePayoutTax) }}
      </div>
    </div>
    <div class="payoutAfterTax"
         v-if="isPayoutTaxActive && Number(possibleWinCombo.possiblePayoutTax) > 0">
      <div>
        {{ translations.general_payout_after_tax || 'Payout After Tax' }}
      </div>
      <div>
        {{ decimalFormatNumber(possibleWinCombo.possibleWinnings - calculatedPayoutTaxCombo) }}
      </div>
    </div>
    <div class="odds">
      <div>
        {{ translations.general_total_odds }}
      </div>
      <div>
        {{ decimalFormatNumber(totalOdds) }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BetslipPossibleWinCombo',
  computed: {
    ...mapGetters('gamesBetslip', [
      'formatNumber',
      'possibleWinCombo',
      'totalOdds',
      'taxes',
      'decimalFormatNumber',
    ]),
    ...mapGetters(['translations']),
    isPayinTaxActive() {
      return !this.taxes.payin.hideTax;
    },
    isPayoutTaxActive() {
      return !this.taxes.payout.hideTax;
    },
  },
};
</script>

<style lang="scss" scoped>
.possibleWinWrapper {
  margin-top: 8px;
  margin-bottom: 8px;
  color: var(--text-primary-1);

  .payinTax, .payoutTax {
    color: var(--text-primary-2);
  }

  .possibleWin, .payinTax, .odds, .payoutTax {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
  }

  .payoutAfterTax {
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    font-size: 17px;
    color: var(--text-primary-1);
    margin: 6px 0;
    padding: 6px 0;
    border-top: 1px solid rgba(var(--text-primary-1-rgb), 0.2);
    border-bottom: 1px solid rgba(var(--text-primary-1-rgb), 0.2);
  }
}

@media only screen and (min-width: 1910px) {
  .possibleWinWrapper {
    .possibleWin, .payinTax, .odds {
      font-weight: 500;
      font-size: 20px;
      line-height: 28px;
    }

    .payoutAfterTax {
      font-size: 21px;
    }
  }
}
</style>
